function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, autocompleteOpen, autocompletePopup, currentAutocompleteLine, customProperty, errors, toCreate, toDelete, tooltipData) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['field-error-tooltip'] = function(field) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((errors[field]) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-property-error-tooltip': true
            },
          }, [__vjadeSafeCode(errors[field])]));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'custom-property-modal-wrapper': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((!toCreate) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-modal", {
            "attrs": __vjadeStringifyAttrsIfObj({
              open: $attr(`open`),
              'grow-to-content': true,
            }),
            "on": {
              change: $helpers.modalStateChange
            },
            "class": {
              'custom-property-modal': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-card-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-card-header-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($helpers.getHeaderText());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("form", {
              "class": Object.assign({}, {
                'for-behaviors': $helpers.isBehavioralProperty()
              }, {
                'custom-property-body': true
              }),
            }, (function() {
              var __jade_nodes = []; /*  Name */
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-property-section': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'custom-property-section-wrapper': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'custom-property-label': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Name");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(jade_mixins['field-error-tooltip'].call(this, 'name'));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'custom-property-section-container': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("input", {
                    "on": {
                      input: $helpers.updateName,
                    },
                    "attrs": __vjadeStringifyAttrsIfObj({
                      autocomplete: 'off',
                    }),
                    "props": {
                      size: 50,
                      type: 'text',
                      value: $helpers.getName(),
                    },
                    "class": Object.assign({}, {
                      'custom-property-error': !!errors.name
                    }, {
                      'custom-property-section-input': true
                    }),
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean))); /*  description */
              __jade_nodes = __jade_nodes.concat(($helpers.isPersisted()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'custom-property-section': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'custom-property-section-wrapper': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'custom-property-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Description");
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'custom-property-description-tooltip': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Optional");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'custom-property-section-container': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("input", {
                      "on": {
                        input: $helpers.updateDescription,
                      },
                      "props": {
                        size: 50,
                        type: 'text',
                        value: $helpers.getDescription(),
                      },
                      "class": {
                        'custom-property-section-input': true
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-property-builder': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($helpers.isBehavioralProperty()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'custom-property-section-wrapper': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'custom-property-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Define condition");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'custom-property-query-events-section': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-query-entry-section", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'entries': JSON.stringify($helpers.getQueryEntries()),
                        'enable-workspace-filter-restrictions': $attr(`enable-workspace-filter-restrictions`),
                        'hide-edit-controls': true,
                        'include-custom-properties': `persisted-only`,
                        'disable-delete-entry': true,
                        'project-id': $attr(`project-id`),
                        'row-label-type': 'none',
                        'metrics-mode': true,
                        'row-limit': 1,
                        'row-types': JSON.stringify($helpers.getBehavioralSelectorTypes()),
                        'event-aggregator-functions': JSON.stringify($helpers.getBehavioralAggregationMethods()),
                        'property-aggregator-functions': JSON.stringify($helpers.getBehavioralAggregationMethods()),
                        'show-special-date-property': true,
                        'track-name': $attr(`track-name`),
                        'user-id': $attr(`user-id`),
                        'workspace-id': $attr(`workspace-id`),
                      }),
                      "on": {
                        update: ev => $helpers.handleQueryEventsSectionUpdate(ev),
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'custom-property-flex-wrapper': true,
                      'custom-property-formula-flex-wrapper': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'custom-property-label': true,
                        'custom-property-formula-label': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Formula");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "on": {
                        click: $helpers.tooltipClicked
                      },
                      "class": {
                        'custom-property-tooltip': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: `info`
                        }),
                      }));
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'max-width': `480px`,
                          placement: `right`,
                          clickable: `true`
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Click to view documentation");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(jade_mixins['field-error-tooltip'].call(this, 'displayFormula'));
                    __jade_nodes = __jade_nodes.concat(h("mp-select", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        'menu-width': 160,
                        'options': JSON.stringify($helpers.getExampleOptions()),
                        'selected-option': 'Insert Example',
                        'disable-search': true,
                      }),
                      "on": {
                        change: $helpers.handleInsertExample,
                      },
                      "class": {
                        'custom-property-example-menu': true
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": Object.assign({}, {
                      'custom-property-error': !!errors.displayFormula
                    }, {
                      'custom-property-input-area': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "key": 'ace-editor',
                      "class": {
                        'custom-property-ace-wrapper': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'custom-property-border': true
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat(h("custom-property-ace-editor", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'composed-properties': JSON.stringify($helpers.getComposedProperties()),
                          'display-formula': $helpers.getDisplayFormula(),
                          'event-names': $attr(`event-names`),
                          'enable-workspace-filter-restrictions': $attr(`enable-workspace-filter-restrictions`),
                          'project-id': $attr(`project-id`),
                          'resource-type': $helpers.getResourceType(),
                          'user-id': $attr(`user-id`),
                          'workspace-id': $attr(`workspace-id`),
                        }),
                        "on": {
                          connect: $helpers.handleEditorConnect,
                          change: $helpers.handleValueChange,
                          autocompleteChange: $helpers.handleEditorAutocompleteChange,
                        },
                        "hook": {
                          insert: $helpers.handleEditorElementInsert,
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'custom-property-border': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat((!!autocompletePopup) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'tooltip-data': JSON.stringify(tooltipData),
                          'placement': autocompleteOpen ? 'right' : 'left',
                          'force-placement': !autocompleteOpen,
                          'always-expanded': true,
                        }),
                        "props": {
                          tooltipPositionParentElement: autocompleteOpen ? autocompletePopup : currentAutocompleteLine,
                        },
                      }));;
                      return __jade_nodes
                    }).call(this)) : undefined);;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'custom-property-info-tooltip': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Press");
                    __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        text: `Period (.)`,
                        theme: `generic`,
                        size: `medium`
                      }),
                    }));
                    __jade_nodes = __jade_nodes.concat("to insert a property and");
                    __jade_nodes = __jade_nodes.concat(h("mp-text-highlight", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        text: `Control + Space`,
                        theme: `generic`,
                        size: `medium`
                      }),
                    }));
                    __jade_nodes = __jade_nodes.concat("to see a list of formula functions.");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-property-footer': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-property-flex-wrapper': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'custom-property-action-wrapper': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(($helpers.isPersisted()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-button", {
                      "on": {
                        click: $helpers.setToDelete
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Delete");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : ($helpers.isSavingRestricted() && !$helpers.isBehavioralProperty()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'upsell-button': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          placement: `right`
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("When you upgrade your plan, custom properties can be created and saved to use across all reports in a project.");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          icon: `share`,
                        }),
                        "on": {
                          click: $helpers.openPricingUpsell
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat("Upgrade to Save");;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : (!$attr(`enable-workspace-filter-restrictions`) && !$helpers.isBehavioralProperty()) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-button", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        disabled: $helpers.isSavingDisabled(),
                      }),
                      "on": {
                        click: () => $helpers.applyProperty(true)
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Save");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `tertiary`
                }),
                "on": {
                  click: $helpers.closeModal
                },
                "class": {
                  'custom-property-button': true,
                  'custom-property-cancel-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Cancel");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(($helpers.isEdit() && $helpers.isPersisted()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($helpers.isSavingRestricted()) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'upsell-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        placement: `left`
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("When you upgrade your plan, custom properties can be created and saved to use across all reports in a project.");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("mp-button", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        theme: `primary`,
                        icon: `share`,
                      }),
                      "on": {
                        click: $helpers.openPricingUpsell
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat("Upgrade to Update");;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-button", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      theme: `primary`,
                      disabled: $helpers.isSavingDisabled(),
                    }),
                    "on": {
                      click: () => $helpers.applyProperty(false)
                    },
                    "class": {
                      'custom-property-button': true,
                      'custom-property-save-button': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("Update");;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `primary`,
                    disabled: $helpers.isSavingDisabled(),
                  }),
                  "on": {
                    click: () => $helpers.applyProperty(false)
                  },
                  "class": {
                    'custom-property-button': true,
                    'custom-property-save-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Apply");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-confirm", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `delete`,
                open: !!toDelete,
                closeable: true
              }),
              "on": {
                change: ev => $helpers.handleDeleteConfirmChange(ev.detail.state),
                submit: ev => ev.detail.action === `confirm` && $helpers.deleteProperty(),
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-confirm-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Delete Custom Property");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-confirm-description': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Are you sure you want to delete \"" + (customProperty.name) + "\"?");
                  __jade_nodes = __jade_nodes.concat("  This action is permanent and cannot be undone.");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-create-entity-modal", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.buildCreateEntityModalAttrs()),
            "on": {
              save: $helpers.handleCreate,
              cancel: $helpers.handleCancelCreate,
              saveAndShare: $helpers.handleCreate,
            },
            "props": {
              existingEntityNames: $helpers.getPersistedCustomPropertyNames(),
            },
          }));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "autocompleteOpen" in locals ? locals.autocompleteOpen : typeof autocompleteOpen !== "undefined" ? autocompleteOpen : undefined, "autocompletePopup" in locals ? locals.autocompletePopup : typeof autocompletePopup !== "undefined" ? autocompletePopup : undefined, "currentAutocompleteLine" in locals ? locals.currentAutocompleteLine : typeof currentAutocompleteLine !== "undefined" ? currentAutocompleteLine : undefined, "customProperty" in locals ? locals.customProperty : typeof customProperty !== "undefined" ? customProperty : undefined, "errors" in locals ? locals.errors : typeof errors !== "undefined" ? errors : undefined, "toCreate" in locals ? locals.toCreate : typeof toCreate !== "undefined" ? toCreate : undefined, "toDelete" in locals ? locals.toDelete : typeof toDelete !== "undefined" ? toDelete : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;